import { useState } from "react";
import { postCsvImportOrderApi } from "../../../../http/api/CsvImportOrderAPI";

const submitCsvForm = (csvForm) => async (onSuccess, onFailure) => {
  try {
    const {files, csvCustomerGroupId, importParameter} = csvForm;
    const formData = new FormData();
    
    
    files.forEach((file) => {
      formData.append('files[]', file);
    })

    formData.append('csvCustomerGroupId', csvCustomerGroupId);
    formData.append('importParameter', new Blob([JSON.stringify(importParameter)], {type: 'application/json'}));

    const res = await postCsvImportOrderApi(formData);
    onSuccess(res.readResults);
  } catch (e) {
    console.log(e);
    onFailure(e);
  }

};

const useCsvImportOrder = () => {

  const [csvForm, setCsvForm] = useState({
    csvCustomerGroupId: 1,
    files: [],
    importParameter: {},
  });

  const {files, csvCustomerGroupId, importParameter} = csvForm;
  const fileInfos = files.map(((file) => ({name: file.name, size: file.size})));

  const submitChangeDirectly = async (changeFunc, onSuccess, onFailure) => {
    const newForm = changeFunc(csvForm);
    setCsvForm(newForm);
    await submitCsvForm(newForm)(onSuccess, onFailure);
  }

  const resetCsvForm = () => {
    setCsvForm((prev) => ({
      ...prev,
      files: [],
      importParameter : {}
    }));
  }

  return {
    form : {
      csvCustomerGroupId,
      fileInfos,
      importParameter
    },   
    submitCsvImport: submitCsvForm(csvForm),
    submitChangeDirectly,
    setCsvForm,
    resetCsvForm
  };
}

export default useCsvImportOrder;